import type { SongType } from "./processingTypes";
import type { ReplaceSongAudioResponse } from "./processingTypes";
import {
  MUSIC_UPLOAD_CONTENT_TYPE,
  computeFileSha256Hex,
  putFileToPresignedUrl,
} from "./processingUploadService";

type ReplaceMutator = (args: {
  trackId: string;
  originalFilename: string;
  sizeBytes: number;
  contentType: "audio/mpeg";
  replaceReason: string;
  songType?: SongType;
  checksumSha256Hint?: string;
}) => { unwrap: () => Promise<ReplaceSongAudioResponse> };

function asSongType(value: string | null | undefined): SongType | undefined {
  return value === "kk-original" || value === "commercial" ? value : undefined;
}

/** DRA-3 — init replace job + PUT fresh bytes to the presigned intake URL. */
export async function initAndPutReplaceSongAudio(opts: {
  replaceSongAudio: ReplaceMutator;
  trackId: string;
  file: File;
  replaceReason: string;
  songType?: string | null;
  onProgress?: (pct: number) => void;
}): Promise<ReplaceSongAudioResponse> {
  const checksumHint = await computeFileSha256Hex(opts.file);
  const songType = asSongType(opts.songType ?? undefined);
  const init = await opts
    .replaceSongAudio({
      trackId: opts.trackId,
      originalFilename: opts.file.name,
      sizeBytes: opts.file.size,
      contentType: MUSIC_UPLOAD_CONTENT_TYPE,
      replaceReason: opts.replaceReason,
      ...(songType ? { songType } : {}),
      ...(checksumHint ? { checksumSha256Hint: checksumHint } : {}),
    })
    .unwrap();

  await putFileToPresignedUrl(
    init.uploadUrl,
    opts.file,
    init.requiredHeaders["Content-Type"],
    opts.onProgress,
  );

  return init;
}
